'use client';
import { useBooqable } from '@dolcevia/lib/hooks/useBooqable';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import bike from '~image/destinations/bike.png';

export const BooqableContent = ({ slugBooqable }: { slugBooqable: string }) => {
  const t = useTranslations('Destinations.Hero');
  useBooqable();
  return (
    <div className="flex flex-col bg-light-yellow p-8 justify-center items-center gap-8 rounded-xl">
      <Image src={bike} alt="person cycling" className="flex" />
      <p className="flex flex-col md:flex-row text-xl items-center justify-center">
        {t('Ce voyage vous plait,')}{' '}
        <span className="text-deep-blue-100 font-bold italic">
          {t('organisez le votre maintenant!')}
        </span>
      </p>
      <div className="booqable-product-button" data-id={slugBooqable} />
    </div>
  );
};

export default BooqableContent;
